// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"3e0d1c99","399":"24e038a5","573":"8f484153","588":"c3ea26f5","683":"c566f254","787":"bed44058"}[chunkId] + ".chunk.js";
};